const functions = require("../functions").default;
const {
    buscarFasePipelines
} = require("../functions/ajax_requests");
const { vaporStoreWithFilename } = require("../functions/vapor_store_helper");

function formatarNumeroBr(valor, casas = 0) {
    return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
    });
}

function formatarMoedaBr(valor) {
    return `R$ ${formatarNumeroBr(valor, 2)}`;
}

function formatarMoedaDolar(valor) {
    return `$ ${Number(valor || 0).toFixed(2)}`;
}

function escaparHtml(texto) {
    return String(texto ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function initRelatorioFinanceiroChunks(context) {
    const $formFinanceiro = $(".js-form-financeiro", context);
    if (!$formFinanceiro.length) {
        return;
    }

    const urlDados = $formFinanceiro.data("url-dados");
    const codigosTxt = $formFinanceiro.data("codigos-txt") || {};
    let carregando = false;
    let itensCarregados = [];

    const totaisIniciais = () => ({
        usuarios: 0,
        usuariosIa: 0,
        resumoIa: 0,
        takeRate: 0,
        contratosSem: 0,
        contratosCom: 0,
        datavalid: 0,
        score: 0,
        acoes: 0,
        faturamento: 0,
        whatsapps: 0,
        mensagens: 0,
        custoMeta: 0,
        disparos: 0,
    });

    const atualizarProgresso = (percentual, label, concluido = false) => {
        const $progress = $(".js-relatorio-financeiro-progress", context);
        const $bar = $(".js-relatorio-financeiro-progress-bar", context);
        $progress.removeClass("d-none");
        $bar
            .css("width", `${percentual}%`)
            .attr("aria-valuenow", percentual)
            .toggleClass("progress-bar-striped", !concluido)
            .toggleClass("progress-bar-animated", !concluido)
            .toggleClass("bg-success", concluido);
        $(".js-relatorio-financeiro-progress-percent", context).text(`${percentual}%`);
        if (label) {
            $(".js-relatorio-financeiro-progress-label", context).text(label);
        }
    };

    const reiniciarProgresso = () => {
        const $bar = $(".js-relatorio-financeiro-progress-bar", context);
        $bar
            .removeClass("bg-success")
            .addClass("progress-bar-striped progress-bar-animated")
            .css("width", "0%")
            .attr("aria-valuenow", 0);
        $(".js-relatorio-financeiro-progress-percent", context).text("0%");
        $(".js-relatorio-financeiro-progress-label", context).text(
            "Processando lojas..."
        );
        $(".js-relatorio-financeiro-progress", context).removeClass("d-none");
    };

    const desabilitarBotaoPesquisar = () => {
        $formFinanceiro.find('button[type="submit"], button:not([type])').attr(
            "disabled",
            "disabled"
        );
    };

    const habilitarBotaoPesquisar = () => {
        $formFinanceiro.find('button[type="submit"], button:not([type])').removeAttr(
            "disabled"
        );
    };

    const limparTabela = () => {
        $(".js-relatorio-financeiro-wrap tbody", context).empty();
        const totais = totaisIniciais();
        renderizarTotais(totais);
        itensCarregados = [];
    };

    const linhaClicksign = (sem, com) =>
        `${formatarNumeroBr(sem)} - <span class="small font-weight-normal">Sem WhatsApp</span><br>${formatarNumeroBr(com)} - <span class="small font-weight-normal">Com WhatsApp</span>`;

    const renderizarTotais = (totais) => {
        $(".js-total-usuarios", context).text(formatarNumeroBr(totais.usuarios));
        $(".js-total-usuarios-ia", context).text(formatarNumeroBr(totais.usuariosIa));
        $(".js-total-resumo-ia", context).text(formatarNumeroBr(totais.resumoIa));
        $(".js-total-take-rate", context).text(formatarMoedaBr(totais.takeRate));
        $(".js-total-contratos", context).html(
            linhaClicksign(totais.contratosSem, totais.contratosCom)
        );
        $(".js-total-datavalid", context).text(formatarNumeroBr(totais.datavalid));
        $(".js-total-score", context).text(formatarNumeroBr(totais.score));
        $(".js-total-acoes", context).text(formatarNumeroBr(totais.acoes));
        $(".js-total-faturamento", context).text(formatarMoedaBr(totais.faturamento));
        $(".js-total-whatsapps", context).text(formatarNumeroBr(totais.whatsapps));
        $(".js-total-mensagens", context).text(formatarNumeroBr(totais.mensagens));
        $(".js-total-custo-meta", context).text(formatarMoedaDolar(totais.custoMeta));
        $(".js-total-disparos", context).text(formatarNumeroBr(totais.disparos));
    };

    const montarLinhaHtml = (item) => {
        const rowClass = item.cliente_og
            ? "table-row-no-status"
            : "table-row-no-status table-danger";

        let statusHtml = "";
        if (item.producao) {
            statusHtml =
                '<span class="badge custom-badge badge-success">Em produção</span>';
        }

        let produtosHtml = "";
        if (item.produtos_crm) {
            produtosHtml +=
                '<span class="badge custom-badge badge-primary">CRM</span> ';
        }
        if (item.produtos_ecommerce) {
            produtosHtml +=
                '<span class="badge custom-badge badge-success">ECOM</span>';
        }

        let chatsHtml = "";
        if (item.chats && item.chats.length) {
            item.chats.forEach((chat) => {
                chatsHtml += `<label class="float-left text-primary">${escaparHtml(
                    chat.pipeline
                )}:</label> <label class="text-success font-weight-bold">${formatarNumeroBr(
                    chat.totalChat
                )}</label><br>`;
            });
        }

        const resumoIaLabel = item.resumo_oportunidades ? "Ativo" : "Inativo";

        return `<tr class="${rowClass}" data-loja-id="${item.id}">
            <td>#${item.id}</td>
            <td>${escaparHtml(item.nome)}</td>
            <td>${escaparHtml(item.cnpj)}</td>
            <td>${escaparHtml(item.nicho)}</td>
            <td>${escaparHtml(item.cliente_og)}</td>
            <td>${statusHtml}</td>
            <td>${escaparHtml(item.nome_plano)}</td>
            <td class="text-right">${item.usuarios_nao_super}</td>
            <td class="text-right">${item.usuarios_ia}</td>
            <td class="text-right">${resumoIaLabel}: ${item.resumo_ia}</td>
            <td>${produtosHtml}</td>
            <td class="text-right">${formatarNumeroBr(item.take_rate, 2)}</td>
            <td class="text-right">${formatarNumeroBr(item.take_rate_valor, 2)}</td>
            <td class="text-right">${linhaClicksign(item.clicksign_sem_whatsapp, item.clicksign_com_whatsapp)}</td>
            <td class="text-right">${item.validacoes_datavalid}</td>
            <td class="text-right">${item.score}</td>
            <td class="text-right">${item.acoes}</td>
            <td class="text-right">${formatarMoedaBr(item.faturamento)}</td>
            <td class="text-right">${formatarNumeroBr(item.whatsapps_cadastrados)}</td>
            <td class="text-right">
                ${chatsHtml}
                <a href="#" class="js-detalhar-mensagens-link" data-loja-id="${item.id}">${formatarNumeroBr(
                    item.total_chat
                )}</a>
            </td>
            <td class="text-right">${formatarMoedaDolar(item.total_fees)}</td>
            <td class="text-right">${formatarNumeroBr(item.total_disparos)}</td>
        </tr>`;
    };

    const baixarTxtLocal = (itens, dataFim) => {
        const linhas = [["serie", "data", "campo", "valor", "contrato"]];

        itens.forEach((item) => {
            let takeRatePercentual = item.take_rate / 100;
            if (takeRatePercentual < 0) {
                takeRatePercentual = 0;
            }
            const takeRate = (takeRatePercentual * item.faturamento * 100)
                .toFixed(2)
                .replace(".", ",");

            const pushLinha = (codigo, valor) => {
                if (!valor) {
                    return;
                }
                linhas.push([1, dataFim, codigo, valor, item.cliente_og]);
            };

            pushLinha(codigosTxt.clicksign, item.total_clicksign);
            pushLinha(codigosTxt.datavalid, item.validacoes_datavalid);
            pushLinha(codigosTxt.score, item.score);
            pushLinha(codigosTxt.acoes, item.acoes);
            pushLinha(codigosTxt.chat, item.total_chat);
            pushLinha(codigosTxt.take_rate, takeRate);
            pushLinha(codigosTxt.usuarios, item.usuarios_nao_super);
            pushLinha(codigosTxt.disparos, item.total_disparos);
            pushLinha(codigosTxt.whatsapp_cadastrados, item.whatsapps_cadastrados);
            pushLinha(
                codigosTxt.valor_meta,
                Number(item.total_fees || 0).toFixed(2)
            );
        });

        const output = linhas.map((linha) => linha.join(";")).join("\n");
        const blob = new Blob([output], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const filename = `Relatorio-${dataFim}-${Date.now()}.txt`;
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const carregarPagina = (page, filtros, totais, baixar, lojasExibidas = 0) => {
        return $.ajax({
            url: urlDados,
            type: "get",
            data: {
                ...filtros,
                page,
                per_page: 10,
            },
        }).then((res) => {
            if (res.error) {
                throw new Error(res.message || "Erro ao carregar relatório.");
            }

            const ocultar = !!filtros.ocultar;
            const $tbody = $(".js-relatorio-financeiro-wrap tbody", context);
            let exibidas = lojasExibidas;

            (res.data || []).forEach((item) => {
                itensCarregados.push(item);

                const totalItem =
                    item.total_clicksign +
                    item.validacoes_datavalid +
                    item.score +
                    item.acoes +
                    Number(item.faturamento || 0) +
                    item.total_chat;

                if (ocultar && totalItem <= 0) {
                    return;
                }

                exibidas++;
                totais.usuarios += item.usuarios_nao_super;
                totais.usuariosIa += item.usuarios_ia;
                totais.resumoIa += item.resumo_ia;
                totais.takeRate += Number(item.take_rate_valor || 0);
                totais.contratosSem += item.clicksign_sem_whatsapp;
                totais.contratosCom += item.clicksign_com_whatsapp;
                totais.datavalid += item.validacoes_datavalid;
                totais.score += item.score;
                totais.acoes += item.acoes;
                totais.faturamento += Number(item.faturamento || 0);
                totais.whatsapps += item.whatsapps_cadastrados;
                totais.mensagens += item.total_chat;
                totais.custoMeta += Number(item.total_fees || 0);
                totais.disparos += item.total_disparos;

                $tbody.append(montarLinhaHtml(item));
            });

            renderizarTotais(totais);

            const lastPage = res.last_page || 1;
            const currentPage = res.current_page || page;
            const totalLojas = res.total || 0;
            const lojasProcessadas = Math.min(
                itensCarregados.length,
                totalLojas
            );
            const percentual =
                totalLojas > 0
                    ? Math.round((lojasProcessadas / totalLojas) * 100)
                    : Math.round((currentPage / lastPage) * 100);

            let labelProgresso = `Processando lojas... (${lojasProcessadas}/${totalLojas})`;
            if (ocultar) {
                labelProgresso += ` · ${exibidas} exibidas`;
            }

            atualizarProgresso(percentual, labelProgresso);

            if (currentPage < lastPage) {
                return carregarPagina(
                    currentPage + 1,
                    filtros,
                    totais,
                    baixar,
                    exibidas
                );
            }

            let labelConcluido = `Concluído (${lojasProcessadas}/${totalLojas})`;
            if (ocultar) {
                labelConcluido = `Concluído (${lojasProcessadas}/${totalLojas}) - ${exibidas} exibidas`;
            }
            atualizarProgresso(100, labelConcluido, true);
            if (baixar) {
                baixarTxtLocal(itensCarregados, res.data_fim || filtros.data_fim);
            }

            return res;
        });
    };

    const iniciarCarregamento = () => {
        if (carregando) {
            return;
        }

        const dataInicio = $formFinanceiro.find('[name="data_inicio"]').val();
        const dataFim = $formFinanceiro.find('[name="data_fim"]').val();
        if (!dataInicio || !dataFim) {
            showToastDanger(context, "Informe o período do relatório.");
            return;
        }

        const filtros = {
            data_inicio: dataInicio,
            data_fim: dataFim,
            ocultar: $formFinanceiro.find('[name="ocultar"]').is(":checked") ? 1 : "",
            detalhar_mensagens: $formFinanceiro.find(".js-detalhar-mensagens").val() || "",
        };
        const baixar = $formFinanceiro.find(".js-baixar-txt").is(":checked");

        carregando = true;
        limparTabela();
        reiniciarProgresso();
        atualizarProgresso(0, "Processando lojas...");
        desabilitarBotaoPesquisar();

        carregarPagina(1, filtros, totaisIniciais(), baixar)
            .then(() => {
                carregando = false;
                habilitarBotaoPesquisar();
            })
            .catch((err) => {
                console.error(err);
                const message =
                    err?.responseJSON?.message ||
                    err?.message ||
                    "Erro ao carregar o relatório financeiro.";
                showToastDanger(context, message);
                atualizarProgresso(
                    $(".js-relatorio-financeiro-progress-bar", context).attr(
                        "aria-valuenow"
                    ) || 0,
                    `Erro: ${message}`,
                    true
                );
                carregando = false;
                habilitarBotaoPesquisar();
            });
    };

    $formFinanceiro.on("submit", function (event) {
        event.preventDefault();
        $formFinanceiro.find(".js-detalhar-mensagens").val("");
        iniciarCarregamento();
    });

    $(context).on("click", ".js-detalhar-mensagens-link", function (event) {
        event.preventDefault();
        const lojaId = $(this).data("loja-id");
        $formFinanceiro.find(".js-detalhar-mensagens").val(lojaId);
        iniciarCarregamento();
    });

    if (String($formFinanceiro.data("carregar-automatico")) === "1") {
        iniciarCarregamento();
    }
}

export function ajaxEvents(context, htmlToImage, isEmpty, aplicarMascaraTelefone) {
    window.dadosCadastroClienteCCL = null;
    window.addEventListener(
        "load",
        function (e) {
            const assinatura = $("#assinatura_iugu_cobranca").val();
            if (assinatura) {
                $.ajax({
                    url: siteUrl(
                        `/painel/assinaturas/dados-assinatura/${assinatura}`
                    ),
                    type: "get",
                    dataType: "html",
                    success: function (res) {
                        let data = JSON.parse(res);
                        data = data.data.expires_at;
                        data = data.split("-");
                        data = data[2] + "/" + data[1] + "/" + data[0];
                        $("#assinatura_data_cobranca").html(data);
                    },
                    error: function (err) {
                        console.log("err", err);
                    },
                });
            }
        },
        false
    );

    $(".js-select-estados", context).on("change", function (e) {
        $.ajax({
            url: siteUrl(`/cidades/busca/${this.value}`),
            type: "get",
            success: function (res) {
                $(".js-select-cidades option", context).remove();
                $(".js-select-cidades", context).append(
                    `<option value="">Selecione</option>`
                );
                res.forEach(function (item) {
                    $(".js-select-cidades", context).append(
                        `<option value="${item.id}">${item.value}</option>`
                    );
                });
            },
            error: function (err) {
                console.log("err", err);
            },
        });
    });

    $(".js-busca-cep", context).on("blur", function (e) {
        functions.buscaCEP(this.value, context);
    });

    $(".js-form-historico-oportunidades", context).on("submit", function (e) {
        e.preventDefault();
        const form = $(this);
        const tabela = form.closest(".js-historico-oportunidades").find(".js-historico-oportunidades-tabela");
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: form.attr("action"),
            type: "get",
            data: form.serialize(),
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                tabela.html(res);
            },
            error: function () {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, "Não foi possível buscar o histórico.");
            },
        });
    });

    $(".js-limpar-historico-oportunidades", context).on("click", function () {
        const form = $(this).closest(".js-form-historico-oportunidades");
        form.find('[name="numero"]').val("");
        form.trigger("submit");
    });

    $(".js-load-eloca-score", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");

        const url = $(this).data("url");
        $.ajax({
            url: url,
            type: "get",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                $(".js-score-eloca", context).replaceWith(res);
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    $(".js-load-campos-customizados-oportunidades", context).on("click", function () {
        const container = $(".js-campos-customizados-oportunidades", context);
        if (container.data("loaded")) {
            return;
        }

        $("#overlayer-loading").addClass("show-overlayer");
        const url = $(this).data("url");
        $.ajax({
            url: url,
            type: "get",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                container.html(res);
                container.data("loaded", true);
            },
            error: function () {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    $(".js-gerar-completar-cadastro-link", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        const btn = $(this);
        const clienteId = $(this).data("id");
        const dominio = $(this).data("dominio");

        $.ajax({
            url: siteUrl(
                `/painel/clientes/cadastro-whatsapp/${clienteId}/null/true/`
            ),
            type: "GET",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                const url = `${dominio}/complementar-cadastro/${res.copiar}?whatsapp=1`;
                if ($(".js-copy-clipboard").length) {
                    $(".js-copy-clipboard", context).attr("data-text", url);
                    $(".js-copy-clipboard", context).removeClass("d-none");
                    $(".js-copy-clipboard", context).click();
                } else {
                    $(".elemento-copy-link", context).attr("data-link", url);
                    $(".elemento-copy-link", context).removeClass("d-none");
                    $(".elemento-copy-link", context).click();
                }

                showToastSuccess(context, res.message);

                $(btn).addClass("d-none");
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                console.error("err", err);
                showToastDanger(context, err.responseJSON.message);
            },
        });
    });

    if ($(".js-backup-modal-abrir", context).length) {
        $(".js-backup-modal-abrir", context).modal("show");
    }

    $(".js-backup-tabelas-todas", context).on("change", function () {
        $(".js-backup-tabela-check", context).prop("checked", $(this).is(":checked"));
    });

    $(context).on("change", ".js-backup-tabela-check", function () {
        const $checks = $(".js-backup-tabela-check", context);
        $(".js-backup-tabelas-todas", context).prop(
            "checked",
            $checks.length > 0 && $checks.length === $checks.filter(":checked").length
        );
    });

    $(".js-gerar-backup-download-link", context).on("click", function () {
        const btn = $(this);
        const url = btn.data("url");
        if (!url) {
            return;
        }

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: url,
            type: "GET",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res || !res.url) {
                    showToastDanger(context, "Não foi possível gerar o link.");
                    return;
                }
                functions.copyTextToClipboard(res.url, btn[0]);
                const htmlOriginal = btn.html();
                btn.html('<span class="text-success">Copiado!</span>');
                setTimeout(function () {
                    btn.html(htmlOriginal);
                }, 2000);
                if (res.message) {
                    showToastSuccess(context, res.message);
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                const message =
                    err.responseJSON && err.responseJSON.message
                        ? err.responseJSON.message
                        : "Não foi possível gerar o link.";
                showToastDanger(context, message);
            },
        });
    });

    initRelatorioFinanceiroChunks(context);

    $(".js-logs-faturas", context).on("click", function (e) {
        let id = $(this).attr("data-id");
        let tipo = $(this).attr("data-tipo");
        $("#listaFaturasModal").html(`
            <tr>
                <td colspan="3">
                    <p class="text-center"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></p>
                </td>
            </tr>
        `);

        $.ajax({
            url: siteUrl(`/painel/assinaturas/logs-fatura/${id}/${tipo}`),
            type: "get",
            success: function (res) {
                $("#listaFaturasModal").html("");
                res.forEach(function (item) {
                    $("#listaFaturasModal").append(
                        `<tr>
                            <td>${item.created_at}</td>
                            <td>${item.description}</td>
                            <td>${item.notes}</td>
                        </tr>`
                    );
                });
                if (res.length == 0) {
                    $("#listaFaturasModal").html(`
                        <tr>
                            <td colspan="3">
                                <p class="text-center">Sem Logs para exibição</p>
                            </td>
                        </tr>
                    `);
                }
            },
            error: function (err) {
                console.error("err", err);
                showToastDanger(context, err.responseJSON.message);
            },
        });
    });

    $(".js-calendario-conflito", context).on("click", function (e) {
        let produtoId = $(this).data("produto-id");
        let produtoNome = $(this).data("produto-nome");
        let conflitos = $(this).data("conflitos");
        $(".js-modal-title-conflitos").html(
            `Conflitos no produto: ${produtoId} - ${produtoNome}`
        );
        $.ajax({
            url: siteUrl(`/painel/patrimonios-conflitos-calendario`),
            type: "get",
            data: { produtoid: produtoId, conflitos: conflitos },
            dataType: "html",
            success: function (res) {
                $(".js-modal-body-conflitos").html(res);

                $(".js-show-modal-conflitos", context).modal({
                    show: true,
                });
            },
            error: function (err) {
                console.log("err", err);
                showToastDanger(context, "Ocorreu um erro");
            },
        });
    });

    $(".js-update-status-assinatura", context).on("change", function () {
        const statusId = $(this).val();
        const assinaturaId = $("#assinatura_id").val();

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(
                `/painel/assinaturas/update-status/${assinaturaId}/${statusId}`
            ),
            type: "put",
            data: {},
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastSuccess(context, res.message);
                window.location.reload();
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, err.message);
            },
        });
    });

    $(context).on("click", ".js-resolver-conflitos", function () {
        const idItem = $(this).data("id-item");

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(`/painel/patrimonios-conflitos/resolver-conflito/`),
            type: "put",
            data: {
                idItem: idItem,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastSuccess(context, res.mensagem);
                window.location.reload();
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, err.mensagem);
            },
        });
    });

    $(context).on("click", ".js-desfazer-resolver-conflito", function () {
        const idItem = $(this).data("id-item");

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(
                `/painel/patrimonios-conflitos/desfazer-resolver-conflito/`
            ),
            type: "put",
            data: {
                idItem: idItem,
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastSuccess(context, res.mensagem);
                window.location.reload();
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastDanger(context, err.mensagem);
            },
        });
    });

    $(context).on("click", ".js-consultar-credito-cliente", function () {
        let oportunidadeId = $(this).data("oportunidade_id").toString();
        oportunidadeId = oportunidadeId.replace(/\D/g, "");
        if (
            oportunidadeId == undefined ||
            oportunidadeId == null ||
            oportunidadeId <= 0
        ) {
            showToastDanger($("body"), "Sem id da oportunidade");
            return;
        }

        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(
                "/painel/consulta-credito-cliente-ccl?oportunidade_id=" +
                    oportunidadeId
            ),
            type: "get",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (!res.erro) {
                    window.location.reload();
                } else {
                    showToastDanger($("body"), res.mensagem);
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    $(context).on("click", ".js-consultar-cliente", function () {
        let cpfCNPJ = normalizarCpfCnpj($("input[name='cnpj']").val());
        if (isEmpty(cpfCNPJ)) {
            showToastDanger($("body"), "Você precisa preencher um CPF ou CNPJ");
            return;
        }

        if (cpfCNPJ.length != 11 && cpfCNPJ.length != 14) {
            showToastDanger($("body"), `CPF ou CNPJ ${cpfCNPJ} inválido`);
            return;
        }

        $(".js-produtos-ccl").html("");
        $("#overlayer-loading").addClass("show-overlayer");

        $.ajax({
            url: siteUrl("/painel/clientes/consulta-dados/" + cpfCNPJ),
            type: "get",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                if (
                    typeof res.dados?.data?.id != "undefined" &&
                    res.dados?.data?.id == null
                ) {
                    showToastDanger($("body"), "Cliente não encontrado");
                } else if (!res.erro) {
                    $("#modalAlertPainel").modal("toggle");
                    let dados = res.dados;
                    if (dados.code == 200) {
                        let data = dados.data;
                        window.dadosCadastroClienteCCL = dados;
                        window.dadosEnderecoCCL = null;
                        if (dados?.tipoPessoa == "pf") {
                            $("span", ".js-cliente-ccl-nome").html(data?.nome);
                            $("span", ".js-cliente-ccl-rg").html(data?.RG);
                            $("span", ".js-cliente-ccl-data_nascimento").html(
                                data?.dataDeNascimento
                            );

                            $("span", ".js-cliente-ccl-email").html(
                                data?.email
                            );
                            $("span", ".js-cliente-ccl-telefone").html(
                                data?.telefone
                            );
                            $("span", ".js-cliente-ccl-bairro").html(
                                data?.endereco?.bairro
                            );
                            $("span", ".js-cliente-ccl-cep").html(
                                functions.preparaCepCCL(data?.endereco?.cep)
                            );
                            $("span", ".js-cliente-ccl-cidade").html(
                                data?.endereco?.municipio
                            );
                            $("span", ".js-cliente-ccl-estado").html(
                                data?.endereco?.uf
                            );
                            $("span", ".js-cliente-ccl-complemento").html(
                                data?.endereco?.complemento
                            );
                            $("span", ".js-cliente-ccl-numero").html(
                                data?.endereco?.numero
                            );
                            $("span", ".js-cliente-ccl-rua").html(
                                data?.endereco?.logradouro
                            );

                            if (data?.endereco?.logradouro) {
                                window.dadosEnderecoCCL = data.endereco;
                            }

                            $("#rua", context).val(data?.endereco?.logradouro);
                            $("#numero", context).val(data?.endereco?.numero);

                            $(".js-cliente-pj").hide();
                            $(".js-cliente-pf").show();
                        } else if (dados?.tipoPessoa == "pj") {
                            let dataAbertura = data?.dataDeAbertura;
                            $("span", ".js-cliente-ccl-fantasia").html(
                                data?.nomeFantasia
                            );
                            $("span", ".js-cliente-ccl-razao").html(
                                data?.razaoSocial
                            );
                            $("span", ".js-cliente-ccl-data_cadastro").html(
                                dataAbertura
                            );
                            $("span", ".js-cliente-ccl-email").html(
                                data?.email
                            );
                            $("span", ".js-cliente-ccl-telefone").html(
                                data?.telefone
                            );
                            $("span", ".js-cliente-ccl-bairro").html(
                                data?.bairroEmpresa
                            );
                            $("span", ".js-cliente-ccl-cep").html(
                                functions.preparaCepCCL(data?.cepEmpresa)
                            );
                            $("span", ".js-cliente-ccl-cidade").html(
                                data?.cidadeEmpresa
                            );
                            $("span", ".js-cliente-ccl-estado").html(
                                data?.estadoEmpresa
                            );
                            $("span", ".js-cliente-ccl-complemento").html(
                                data?.complementoEmpresa
                            );
                            $("span", ".js-cliente-ccl-numero").html(
                                data?.numeroEmpresa
                            );
                            $("span", ".js-cliente-ccl-rua").html(
                                data?.ruaEmpresa
                            );

                            $(".js-cliente-pf").hide();
                            $(".js-cliente-pj").show();
                        }
                    } else {
                        showToastDanger($("body"), "Não encontrado");
                    }
                } else {
                    showToastDanger($("body"), res.mensagem);
                }
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    // ------- Vincular cliente modal handlers -------
    // Busca e vinculação usados na modal de contatos (resources/views/painel/clientes/partials/contatos.blade.php)
    $(context).on('input', '#vincular-search', function () {
        const $modal = $('#vincularModal');
        const parentId = $modal.data('parent-id');
        const csrf = $modal.data('csrf');
        const q = $(this).val().trim();

        clearTimeout(window._vincular_timeout);
        window._vincular_timeout = setTimeout(function () {
            const url = siteUrl('/painel/clientes/search');
            $.ajax({
                url: url,
                method: 'GET',
                data: { q: q, parent_id: parentId },
                dataType: 'text',
                headers: { Accept: 'application/json' },
                success: function (rawResp) {
                    let resp = null;
                    try {
                        resp = JSON.parse(rawResp);
                    } catch (e) {
                        const text = rawResp || '';
                        if (text.indexOf('<!DOCTYPE') !== -1 || text.indexOf('<html') !== -1) {
                            $('#vincular-results').html('<div class="text-danger">Resposta HTML recebida (possível redirecionamento). Verifique autenticação.</div>');
                            return;
                        }
                        // se não for JSON nem HTML, tratar como erro
                        $('#vincular-results').html('<div class="text-danger">Resposta inesperada do servidor.</div>');
                        return;
                    }

                    let items = [];
                    if (Array.isArray(resp)) {
                        items = resp;
                    } else if (resp && Array.isArray(resp.data)) {
                        items = resp.data;
                    } else if (resp && typeof resp === 'object') {
                        items = Object.keys(resp).filter(k => !isNaN(k)).map(k => resp[k]);
                    }

                    const $container = $('#vincular-results');
                    if (!items.length) {
                        $container.html('<div class="text-muted">Nenhum resultado</div>');
                        return;
                    }
                    let html = '<div class="list-group">';
                    items.forEach(function (i) {
                        const label = i.pj ? (i.nome_fantasia || i.razao_social || i.nome) : (i.nome || i.nome_fantasia || i.razao_social);
                        const info = i.cnpj ? ' - ' + i.cnpj : '';
                        html += `<a href="#" class="list-group-item list-group-item-action vincular-row d-flex align-items-center" data-id="${i.id}">
                            <div>
                                <strong>${label}</strong><br/><small class="text-muted">${info}</small>
                            </div>
                        </a>`;
                    });
                    html += '</div>';
                    $container.html(html);
                },
                error: function (xhr, textStatus, errorThrown) {
                    const text = xhr.responseText || '';
                    if (text.indexOf('<!DOCTYPE') !== -1 || text.indexOf('<html') !== -1) {
                        $('#vincular-results').html('<div class="text-danger">Resposta HTML recebida (possível redirecionamento). Verifique autenticação.</div>');
                    } else if (xhr.status === 419 || xhr.status === 401) {
                        $('#vincular-results').html('<div class="text-danger">Sessão expirada ou não autenticado (status ' + xhr.status + '). Faça login novamente.</div>');
                    } else {
                        $('#vincular-results').html('<div class="text-danger">Erro na busca</div>');
                    }
                }
            });
        }, 300);
    });

    // tornar as linhas clicáveis (list-group-item), permitir deseleção ao clicar novamente
    $(context).on('click', '.vincular-row', function (e) {
        e.preventDefault();
        const $row = $(this);
        const id = $row.data('id');

        if ($row.hasClass('active')) {
            $row.removeClass('active');
            $('#vincular-selected-id').val('');
        } else {
            $('.vincular-row.active').removeClass('active');
            $row.addClass('active');
            $('#vincular-selected-id').val(id);
        }
    });

    $(context).on('click', '#vincular-confirm', function () {
        const $modal = $('#vincularModal');
        const parentId = $modal.data('parent-id');
        const csrf = $modal.data('csrf');
        const selected = $('#vincular-selected-id').val();
        if (!selected) {
            showToastDanger($("body"), "Selecione um cliente.");
            return;
        }

        $.ajax({
            url: siteUrl('/painel/clientes/vincular'),
            method: 'POST',
            data: { cliente_id: selected, parent_id: parentId },
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') || csrf },
            success: function (resp) {
                if (resp && resp.success) {
                    location.reload();
                } else {
                    showToastDanger($("body"), (resp && resp.message) || 'Erro ao vincular');
                }
            },
            error: function (err) {
                showToastDanger($("body"), err.responseJSON.message || 'Erro ao vincular');
            }
        });
    });

    // Desvincular cliente (remover parent_id)
    $(context).on('click', '.js-desvincularpai', function () {
        const $btn = $(this);
        const clienteId = $btn.data('cliente-id');
        $.ajax({
            url: siteUrl(`/painel/clientes/${clienteId}/desvincularpai`),
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success: function (resp) {
                if (resp && resp.success) {
                    showToastSuccess(context, "Contato desvinculado com sucesso");
                    setTimeout(() => { 
                     location.reload();
                    }, 1500);
                } else {
                    showToastDanger($("body"), (resp && resp.message) || 'Erro ao desvincular');
                }
            },
            error: function () {
                showToastDanger($("body"), 'Erro ao desvincular');
            }
        });
    });

    $(context).on(
        "click",
        ".js-sendmessage-dashboard-whatsapp-web",
        function () {
            let sessionId = $(this).data("session-id");
            $.ajax({
                url: siteUrl(
                    `/painel/dashboard-whatsapp-web/send-message/${sessionId}`
                ),
                type: "get",
                xhrFields: {
                    withCredentials: true
                },
                success: function (res) {
                    if (!res.error && !isEmpty(res.messageId)) {
                        showToastSuccess(context, "Mensagem enviada");
                    } else {
                        showToastDanger(
                            context,
                            `Mensagem não enviada: , ${res.message}`
                        );
                    }
                },
                error: function (err) {
                    showToastDanger(
                        context,
                        "Ocorreu um erro ao tentar enviar a mensagem"
                    );
                },
            });
        }
    );

    $(".js-registrar-channel", context).on("click", function (e) {
        $.ajax({
            url: siteUrl(`/painel/lojas/goto/channel`),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                channel: $("input[name='voip_goto_channel']").val(),
                account_key: $("textarea[name='voip_goto_account_key']").val(),
            },
            success: function (res) {
                if (!res.error) {
                    showToastSuccess(context, res.message);
                } else {
                    showToastDanger(context, res.message);
                }
            },
            error: function (err) {
                console.log(err);
                showToastDanger(
                    context,
                    "Ocorreu um erro, consulte o log do console"
                );
            },
        });
    });

    $(".js-delete-channel", context).on("click", function (e) {
        $.ajax({
            url: siteUrl(
                `/painel/lojas/goto/channel/${$(this).data("channel-id")}`
            ),
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            type: "delete",
            success: function (res) {
                if (!res.error) {
                    window.location.reload(true);
                } else {
                    showToastDanger(context, res.message);
                }
            },
            error: function (err) {
                console.log(err);
                showToastDanger(
                    context,
                    "Ocorreu um erro, consulte o log do console"
                );
            },
        });
    });

    $(".js-mover-oportunidades", context).on("click", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        const btn = this;
        const modal = $(this).closest(".modal");
        let dados = $(modal).find(".custom-select").val();
        dados = dados.split("-");
        const usuario = $(this).attr("item-id");
        const pipeline = $(this).attr("data-pipeline");
        let novaPipeline = null
        if ($(`#pipeline-${pipeline}-padrao`).is(':checked')) {
            $(`#pipeline-${pipeline}-padrao`).prop("checked", false);
            if($(`.js-check-pipeline-user:checked:first`)) {
                novaPipeline = $(`.js-check-pipeline-user:checked:first`).attr("id");
                $(`#pipeline-${novaPipeline}-padrao`).prop("checked", true)
            }
        }
        
        $.ajax({ 
            url: siteUrl(
                `/painel/usuarios/mover-oportunidade-pipeline/${usuario}`
            ),
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                pipeline_id: dados[0],
                novo_usuario_id: dados[1],
                nova_pipeline: novaPipeline
            },
            type: "post",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                showToastSuccess(context, res.message);
                const bloco = $(modal)
                    .closest(".bloco-pipeline")
                    .find(".js-pipeline-bloco");
                $(bloco).attr("data-id", 0);
            },
            error: function (err) {
                $("#overlayer-loading").removeClass("show-overlayer");
                console.log(err);
                const pipeline = $(btn).attr("data-pipeline");
                $(`input[name='pipelines[${pipeline}]']`).trigger("click");
                showToastDanger(context, "Ocorreu um erro!");
            },
        });
    });

    $(".js-check-pipeline-padrao").on("click", function (e) {
        const val = $(this).val();
        if (!$(`#${val}`).is(":checked")) {
            $(`#${val}`).trigger('click');
            $(`#${val}`).prop('checked', true);
        }
    });

    $(".js-check-pipeline-user").on("click", function (e) {
        const val = $(this).val();
        if (!$(this).is(":checked") &&
            $(`#pipeline-${val}-padrao`).is(":checked")
        ) {
            $(`#pipeline-${val}-padrao`).prop("checked", false);
            let novaPipeline = null;
            if($(`.js-check-pipeline-user:checked:first`)) {
                novaPipeline = $(`.js-check-pipeline-user:checked:first`).attr("id");
                $(`#pipeline-${novaPipeline}-padrao`).prop("checked", true)
            }
        }
    });

    $(".js-att-preco", context).on("blur", function (e) {
        const td = $(this).closest("td");
        const idProduto = $(".js-id-produto", td).val();
        const tipo = $(".js-tipo").val();
        const etapa = $(".js-etapa").val();

        const precoAntigoProduto = parseFloat(
            $(".js-valor-antigo-produto", td).val()
        );

        const novoPrecoProduto = parseFloat(
            this.value.replaceAll(".", "").replace(",", ".")
        );

        $("#overlayer-loading").addClass("show-overlayer");

        $.ajax({
            url: siteUrl(`/painel/${tipo}/${etapa}/att/${idProduto}`),
            type: "post",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                preco: novoPrecoProduto,
            },
            success: function (res) {
                functions.recalcularPrecoProdutos(context);

                $("#overlayer-loading").removeClass("show-overlayer");

                if (
                    (novoPrecoProduto > 0 && precoAntigoProduto <= 0) ||
                    (novoPrecoProduto <= 0 && precoAntigoProduto > 0)
                ) {
                    location.reload();
                }
            },
            error: function (err) {
                console.log("err", err);
            },
        });
    });

    $(".js-switch-custo-instalacao", context).on("change", function () {
        let url = $("#url-remove-custo").val();
        if ($(this).is(":checked")) {
            url = $("#url-add-custo").val();
            const custo = parseFloat($(".js-custo-instalacao", context).val());
            $(".js-show-custo-instalacao", context).html(
                `R$ ${custo.toFixed(2).replace(".", ",")}`
            );
        } else {
            $(".js-show-custo-instalacao", context).html("Sem custo");
        }
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: url,
            type: "get",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
        functions.recalcularPrecoProdutos(context);
    });

    $(".js-file-input", context).on("change", function () {
        const input = this;
        const extensoesAceitas = $(this).data("extensao");
        const maxSize = $(this).data("max-size");
        const url = $(this).val();
        const ext = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
        const inputId = input.id.replaceAll("[", "-").replaceAll("]", "-");
        const bloco = $(this).closest(".custom-form-file");

        if (!input.files || !input.files[0]) {
            $(input).addClass("is-invalid");
            return;
        }

        let fileSize = input.files[0].size / 1000;

        if (
            fileSize < maxSize &&
            extensoesAceitas.find((extensao) => extensao == ext)
        ) {
            const reader = new FileReader();

            let unidadeMedida = "KB";

            if (fileSize > 1000) {
                unidadeMedida = "MB";
                fileSize = fileSize / 1000;
            }

            let fileTotal = `<span class="small">Tamanho: ${fileSize.toFixed(
                2
            )} ${unidadeMedida} </span>`;

            const imagens = ["jpg", "jpeg", "png", "gif", "webp", "ico"];

            $(".js-file-size", bloco).html(fileTotal);

            if (imagens.find((img) => img == ext)) {
                $(".uploading-loading", bloco).addClass("active");
            } else {
                $("#overlayer-loading").addClass("show-overlayer");
            }

            reader.onload = function (e) {
                if (imagens.find((img) => img == ext)) {
                    $(`#thumb-${inputId}`, context).attr(
                        "src",
                        e.target.result
                    );
                    $(`#thumb-${inputId}`, context)
                        .closest("div")
                        .removeClass("d-none");
                }
            };
            reader.readAsDataURL(input.files[0]);

            vaporStoreWithFilename(input.files[0], {
                baseURL: siteUrl("/painel"),
                progress: (progress) => {
                    this.uploadProgress = Math.round(progress * 100);
                },
            }).then((response) => {
                const filename = this.files[0].name;
                const labelText = $('label[for="' + this.id + '"]');
                labelText.text(filename);
                $(`#id-input-${inputId}`, context).val(response.uuid);
                $(`#id-input-${inputId}-ext`, context).val(ext);
                if (imagens.find((img) => img == ext)) {
                    $(".uploading-loading", bloco).removeClass("active");
                } else {
                    $("#overlayer-loading").removeClass("show-overlayer");
                }
                if ($(input).hasClass("is-invalid")) {
                    $(input).removeClass("is-invalid");
                }
            });
        } else {
            const labelText = $('label[for="' + this.id + '"]');
            labelText.text("Arquivo");
            $(input).addClass("is-invalid");
        }
    });

    if ($(`.js-row-whatsapp-web-qrcode`, context).length) {
        let sessaoId = $(`.js-row-whatsapp-web-qrcode`, context).data(
            "sessao-id"
        );
        setInterval(function () {
            functions.qrCodeAjax(context, sessaoId);
        }, 10000);
    }

    let popupAuth2Goto = "";
    $(".js-goto-authorization-code", context).on("click", function (e) {
        let state = $(this).data("state");
        let urlCallBack = siteUrl(`/api/goto/retorno-oauth2/${window.lojaId}/`);
        let url = `https://authentication.logmeininc.com/oauth/authorize?response_type=code&client_id=${window.clienteId}&state=${state}&redirect_uri=${urlCallBack}`;
        let parametrosPopup =
            "width=600,height=400,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes";
        popupAuth2Goto = window.open(url, "_blank", parametrosPopup);
        popupAuth2Goto.onunload = function () {
            const parametrosCallBack = popupAuth2Goto.location.href;
            if (parametrosCallBack.startsWith(urlCallBack)) {
                const BuscaParametros = new URLSearchParams(
                    parametrosCallBack.split("?")[1]
                );
                const code = BuscaParametros.get("code");
                if ($("input[name='authorization_code']").length) {
                    $("input[name='authorization_code']").val(code);
                }
                if ($("input[name='voip_goto_authorization_code']").length) {
                    $("input[name='voip_goto_authorization_code']").val(code);
                    $("input[name='voip_goto_access_token']").val("");
                    $("input[name='voip_goto_refresh_token']").val("");
                    $("input[name='voip_goto_token_principal']").val("");
                }
            }
        };
    });

    $(".js-enviar-orcamento-conversa", context).on("click", function () {
        const configId = $("#config_pdf").val();
        $("#escolherConfig").modal("toggle");
        $("#modalImprimirOportunidade").modal("toggle");
        $(`#bloco-chat-tab-${configId}`, context).trigger("click");
        $(".js-input-chat", context).val(" ");
        const node = document.querySelector(
            "#modalImprimirOportunidadeConteudo"
        );
        
        const filter = (node) => {
            const exclusionClasses = [];
            return !exclusionClasses.some((classname) =>
                node.classList?.contains(classname)
            );
        };

        htmlToImage
            .toPng(node, {
                filter: filter,
                skipFonts: true,
            })
            .then(function (dataUrl) {
                const sliceSize = 1024;
                dataUrl = dataUrl.replace("data:image/png;base64,", "");
                const byteCharacters = window.atob(dataUrl);
                const bytesLength = byteCharacters.length;
                const slicesCount = Math.ceil(bytesLength / sliceSize);
                const byteArrays = new Array(slicesCount);

                for (
                    let sliceIndex = 0;
                    sliceIndex < slicesCount;
                    ++sliceIndex
                ) {
                    let begin = sliceIndex * sliceSize;
                    let end = Math.min(begin + sliceSize, bytesLength);

                    let bytes = new Array(end - begin);
                    for (
                        let offset = begin, i = 0;
                        offset < end;
                        ++i, ++offset
                    ) {
                        bytes[i] = byteCharacters[offset].charCodeAt(0);
                    }
                    byteArrays[sliceIndex] = new Uint8Array(bytes);
                }
                const blop = new Blob(byteArrays, { type: "image/png" });
                const fileName = `orcamento-${configId}.png`;
                const file = new File([blop], fileName, {
                    type: "image/png",
                });
                functions.uploadImg(
                    file,
                    "image",
                    $(`#input-file-chat-${configId}`, context)[0]
                );
            })
            .catch(function (error) {
                showToastDanger(
                    context,
                    "Ocorreu uma falha ao gerar a imagem."
                );
                console.error("oops, alog deu errado!", error);
            });
    });

    $(".js-autocomplete-produto-relatorio-assinatura", context).each(
        function () {
            const input = this;
            $(input)
                .autocomplete({
                    source: siteUrl(
                        "/painel/produtos/busca/autocomplete?crm=true"
                    ),
                    minLength: 2,
                    select: function (event, ui) {
                        $(".js-busca-form-filtros-relatorio-assinatura").val(
                            ui.item.id
                        );
                    },
                    error: function (err) {
                        $("#overlayer-loading").removeClass("show-overlayer");
                        showToastDanger(context);
                    },
                })
                .autocomplete("instance")._renderItem = function (ul, item) {
                let sku = "";
                if (item.sku && item.sku != null) {
                    sku = ` - SKU: ${item.sku}`;
                }

                return $("<li class='lista-produto'>")
                    .append(`#${item.id} - ${item.nome}${sku}`)
                    .appendTo(ul);
            };
        }
    );

    $(".js-file-full-input", context).on("change", function () {
        const input = this;
        const extensoesAceitas = $(this).data("extensao");
        const maxSize = $(this).data("max-size");
        const url = $(this).val();
        const ext = url.substring(url.lastIndexOf(".") + 1).toLowerCase();
        const inputId = input.id.replaceAll("[", "-").replaceAll("]", "-");
        const bloco = $(this).closest(".custom-form-file");

        if (!input.files || !input.files[0]) {
            $(input).addClass("is-invalid");
            return;
        }

        let fileSize = input.files[0].size / 1000;

        if (
            fileSize < maxSize &&
            extensoesAceitas.find((extensao) => extensao == ext)
        ) {
            const reader = new FileReader();

            let unidadeMedida = "KB";

            if (fileSize > 1000) {
                unidadeMedida = "MB";
                fileSize = fileSize / 1000;
            }

            let fileTotal = `<span class="small">Tamanho: ${fileSize.toFixed(
                2
            )} ${unidadeMedida} </span>`;

            $(".js-file-full-size", bloco).html(fileTotal);

            if (extensoesAceitas.find((img) => img == ext)) {
                $(".uploading-loading", bloco).addClass("active");
            } else {
                $("#overlayer-loading").addClass("show-overlayer");
            }

            reader.onload = function (e) {
                if (extensoesAceitas.find((img) => img == ext)) {
                    if (ext != "pdf") {
                        $(`#thumb-${inputId}`, context).attr(
                            "src",
                            e.target.result
                        );
                    } else {
                        $(`#thumb-pdf-${inputId}`, context).removeClass(
                            "d-none"
                        );
                        $(`#thumb-${inputId}`, context).addClass("d-none");
                        $(`#thumb-pdf-${inputId}`, context).attr(
                            "data",
                            e.target.result
                        );
                    }

                    $(`#thumb-${inputId}`, context)
                        .closest("div")
                        .removeClass("d-none");
                }
            };
            reader.readAsDataURL(input.files[0]);

            vaporStoreWithFilename(input.files[0], {
                baseURL: siteUrl("/painel"),
                progress: (progress) => {
                    this.uploadProgress = Math.round(progress * 100);
                },
            }).then((response) => {
                const filename = this.files[0].name;
                const mimeType = this.files[0].type;
                const labelText = $('label[for="' + this.id + '"]');
                labelText.text(filename);
                $(`#id-input-${inputId}`, context).val(response.uuid);
                $(`#id-input-${inputId}-extension`, context).val(ext);
                $(`#id-input-${inputId}-name-file`, context).val(filename);
                $(`#id-input-${inputId}-mime`, context).val(mimeType);
                if (extensoesAceitas.find((img) => img == ext)) {
                    $(".uploading-loading", bloco).removeClass("active");
                } else {
                    $("#overlayer-loading").removeClass("show-overlayer");
                }
                if ($(input).hasClass("is-invalid")) {
                    $(input).removeClass("is-invalid");
                }
            });
        } else {
            const labelText = $('label[for="' + this.id + '"]');
            labelText.text("Arquivo");
            $(input).addClass("is-invalid");
        }
    });

    $(context).on("click", "#play-voice-btn", function () {
        const voiceId = $('input[name="eleven_labs_voice_id"]', context).val();

        if (!voiceId) {
            showToastWarning(context, "Informe o Voice ID primeiro.");
            return;
        }

        const $button = $(this);
        $button.prop("disabled", true);
        $("#btn-spinner").removeClass("d-none");
        $(".btn-text").addClass("d-none");

        $.ajax({
            url: "/elevenlabs/preview-voice",
            method: "GET",
            data: { voice_id: voiceId },
            success: function (response) {
                if (response.audio_url) {
                    const audio = new Audio(response.audio_url);
                    audio.play();

                    audio.onended = function () {
                        $button.prop("disabled", false);
                        $("#btn-spinner").addClass("d-none");
                        $(".btn-text").removeClass("d-none");
                    };
                } else {
                    showToastWarning(context, "Áudio não encontrado.");
                }
            },
            error: function () {
                showToastDanger(
                    context,
                    "Erro ao buscar o áudio da ElevenLabs."
                );
            },
            complete: function () {
                if (!$button.prop("disabled")) return;
                $button.prop("disabled", false);
                $("#btn-spinner").addClass("d-none");
                $(".btn-text").removeClass("d-none");
            },
        });
    });


    $(".js-consulta-cnpj").on("click", function () {
        if (
            $(".js-change-pj").is(":checked") ||
            $(".js-select-pj").val() == "3" ||
            $(".js-select-pj").val() == "4"
        ) {
            let cpfCNPJ = sanitizeCnpj($(".js-cpf-cnpj").val());
    
            if (isEmpty(cpfCNPJ)) {
                showToastDanger(context, "Você precisa preencher um CPF ou CNPJ");
                return;
            }
    
            $("#overlayer-loading").addClass("show-overlayer");
    
            $.ajax({
                url: siteUrl("/painel/clientes/consulta-cnpj/" + cpfCNPJ),
                type: "get",
                success: function (res) {
                    $("#overlayer-loading").removeClass("show-overlayer");
                    console.log(res);
                    const data = res.result;
    
                    if (!data) {
                        showToastDanger(
                            context,
                            "Não foi possível obter os dados do CNPJ"
                        );
                        return;
                    }
    
                    $("input[name='data_cadastro']").val(data.abertura);
                    $("input[name='email']").val(data.email);
                    $("input[name='bairro']").val(data.bairro);
                    $("input[name='cep']").val(data.cep.replace(/\D/g, ""));
                    $("input[name='complemento']").val(data.complemento);
                    $("input[name='numero']").val(data.numero);
                    $("input[name='rua']").val(data.logradouro);
    
                    if (data.uf) {
                        const estadoSelecionado = $(
                            ".js-select-estados option"
                        ).filter(function () {
                            return (
                                $(this)
                                    .text()
                                    .indexOf(data.uf + " -") >= 0
                            );
                        });
    
                        if (estadoSelecionado.length) {
                            $(".js-select-estados")
                                .val(estadoSelecionado.val())
                                .trigger("change");
                        }
                    }
    
                    setTimeout(function () {
                        if (data.municipio) {
                            const cidadeFormatada = data.municipio
                                .normalize("NFD")
                                .replace(/[\u0300-\u036f]/g, "")
                                .toUpperCase();
    
                            const cidadeSelecionada = $(
                                ".js-select-cidades option"
                            ).filter(function () {
                                const textoOpcao = $(this)
                                    .text()
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f]/g, "")
                                    .toUpperCase();
                                return textoOpcao === cidadeFormatada;
                            });
    
                            if (cidadeSelecionada.length) {
                                $(".js-select-cidades").val(
                                    cidadeSelecionada.val()
                                );
                            }
                        }
                    }, 1000);
    
                    if (!$("input[name='telefone1']").prop("readonly")) {
                        $("input[name='telefone1']").val(
                            aplicarMascaraTelefone(data.telefone.replace(/\D/g, ""))
                        );
                    }
    
                    $("input[name='nome_fantasia']").val(data.fantasia);
                    $("input[name='razao_social']").val(data.nome);
    
                    // Adicionando mensagem de sucesso
                    showToastSuccess(context, "Dados do CNPJ obtidos com sucesso!");
                },
                error: function (err) {
                    $("#overlayer-loading").removeClass("show-overlayer");
                    showToastDanger(context, "Erro ao consultar o CNPJ");
                },
            });
        } else {
            showToastWarning(context, "Consulta apenas para Pessoa Jurídica.");
            return;
        }

    });

    $(".js-oauth-facebook", context).on("click", function (e) {
        let id = $(this).data("id");

        if (isEmpty(id)) {
            return;
        }

        let parametrosPopup =
            "width=650,height=810,left="+(window.innerWidth-600)/2+",toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes";
        const popup = window.open(
            siteUrl(`/painel/facebook/oauth/${id}`),
            "_blank",
            parametrosPopup
        );

        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                window.location.reload(true);
            }
        }, 1000);
    });

    $(".js-oauth-instagram", context).on("click", function (e) {
        let id = $(this).data("id");

        if (isEmpty(id)) {
            return;
        }

        let parametrosPopup =
            "width=650,height=810,left="+(window.innerWidth-600)/2+",toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes";
        const popup = window.open(
            siteUrl(`/painel/instagram/oauth/${id}`),
            "_blank",
            parametrosPopup
        );

        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                window.location.reload(true);
            }
        }, 1000);
    });

    $(".js-oauth-whatsapp-cloud", context).on("click", function (e) {
        let id = $(this).data("id");

        if (isEmpty(id)) {
            return;
        }

        let parametrosPopup =
            "width=650,height=572,left="+(window.innerWidth-600)/2+",toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes";
        const popup = window.open(
            siteUrl(`/painel/whatsapp-cloud/oauth/${id}`),
            "_blank",
            parametrosPopup
        );

        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                window.location.reload(true);
            }
        }, 1000);
    });

    $(".js-input-pipe-line-regiao", context).on("change", function () {
        let id = $(this).find(":selected").val();
        buscarFasePipelines(id, ".js-input-pipe-line-regiao-fase");
    });
}
